TS.ns('WL');

WL.documentSyncStateEditModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;
        me.parent(config);
    },
    
    createProperties: function (config) { 
        var me = this;
        me.parent(config);    

        var documentSyncStateCollection = me.getDomainProperty('grdDocumentSyncStateCollection_Property');
        if (documentSyncStateCollection) {
            documentSyncStateCollection.on('cellBeginEdit', me.documentSyncStateCollection_onCellBeginEdit);
            documentSyncStateCollection.on('cellValueChanged', me.documentSyncStateCollection_onCellValueChanged);
        }
    },   

    documentSyncStateCollection_onCellBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();  
            
        if (e.fieldName == 'DestinationStateId' && e.record.DocumentSyncTypeId() == owner.AutomaticStateTransitionId())
            e.preventDefault();
    },

    documentSyncStateCollection_onCellValueChanged: function (e) {
        var me = this,
            owner = me._getOwner();

        if (e.fieldName == 'DocumentSyncTypeId' && e.newValue == owner.AutomaticStateTransitionId()) {
            e.record.DestinationInitialStateId(null);
            e.record.DestinationInitialStateName(null);
            e.record.DestinationFinalStateId(null);
            e.record.DestinationFinalStateName(null);
        }
    },
});

